export default "__VITE_ASSET__kjves17G__"